// extracted by mini-css-extract-plugin
export default {"menu":"Menu-module_menu__ju27H","separator":"Menu-module_separator__Cb27O"};